<div class="app-menu" [class.rail]="railMode">
  <div class="app-menu-container">
    @for (list of menu; track list; let i = $index) {
      <ng-container>
        @if (list.title.length) {
          <div class="app-menu-header">
            <h2 class="mat-title">{{ list.title }}</h2>
          </div>
        }
        <div class="app-menu-list">
          @for (item of list.items; track item) {
            <a
              matRipple
              matRippleColor="#FFFFFF4A"
              class="app-menu-button"
              [class.active]="(activeMenu$ | async) === item.id"
              [attr.aria-label]="item.label"
              [routerLink]="[item.route]"
              *appSecurableResource="item.resourceAccess"
            >
              <mat-icon>{{ item.icon }}</mat-icon>
              @if (!railMode) {
                <span
                  class="animate__animated animate__faster animate__fadeIn"
                  >{{ item.label }}</span
                >
              }
            </a>
          }
        </div>
        @if (i < menu.length - 1) {
          <div class="menu-divider"></div>
        }
      </ng-container>
    }
  </div>
  <div class="app-menu-footer">
    <a
      href="#security"
      class="security-privacy"
      (click)="openSecurityPrivacy($event)"
    >
      <mat-icon class="material-icons-outlined">privacy_tip</mat-icon>
      @if (!railMode) {
        <span>Security & Privacy</span>
      }
    </a>
  </div>
</div>
